import { Link } from 'react-router-dom'
import akhiratLogo from '../assets/images/akhirat-logo.png'

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-neutral-50 py-10">
      <div className="mx-auto max-w-3xl px-4">
        <div className="rounded-lg border border-neutral-200 bg-white p-6 shadow-sm sm:p-10">
          <div className="mb-6 flex items-center gap-3">
            <img src={akhiratLogo} alt="Akhirat" className="h-12 w-12 object-contain" />
            <h1 className="font-serif text-3xl font-bold text-neutral-900">Akhirat</h1>
          </div>

          <p className="mb-4 leading-relaxed text-neutral-800">
            Akhirat is a funeral services coordination platform for Malaysian Muslim
            families — honouring Islamic traditions with dignity and respect. It brings
            the arrangements that matter during a loss into one place, so families can
            focus on what counts.
          </p>

          <h2 className="mb-2 mt-6 text-lg font-semibold text-neutral-900">What the platform provides</h2>
          <ul className="mb-4 list-disc space-y-1 pl-6 text-neutral-800">
            <li>Ambulance transport and hearse bookings</li>
            <li>Burial plot reservations and cemetery services</li>
            <li>Care requests and funeral coordination</li>
            <li>Family tree and memorial record-keeping</li>
            <li>Infaq and charitable donation programmes</li>
            <li>A souvenir marketplace for Islamic goods</li>
            <li>Member wallet with secure online payments</li>
            <li>My Will — beneficiary designation with a printable Letter of Conditional Hibah / Wasiat</li>
          </ul>

          <h2 className="mb-2 mt-6 text-lg font-semibold text-neutral-900">Who it is for</h2>
          <p className="mb-4 text-neutral-800">
            Families arranging funeral and burial services, members planning ahead for
            themselves and their loved ones, and approved service providers — ambulance
            operators, ustaz, cemetery operators, and Islamic souvenir vendors.
          </p>

          <h2 className="mb-2 mt-6 text-lg font-semibold text-neutral-900">Who we are</h2>
          <p className="mb-4 text-neutral-800">
            The platform is operated by B TAG VENTURE Sendirian Berhad (Company No.
            201901031508 (1340838-P)), Malaysia.
          </p>

          <h2 className="mb-2 mt-6 text-lg font-semibold text-neutral-900">Policies</h2>
          <ul className="mb-4 list-disc space-y-1 pl-6 text-neutral-800">
            <li>
              <Link to="/privacy-policy" className="text-primary-700 hover:underline">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-of-service" className="text-primary-700 hover:underline">
                Terms of Service
              </Link>
            </li>
          </ul>

          <h2 className="mb-2 mt-6 text-lg font-semibold text-neutral-900">Contact</h2>
          <p className="text-neutral-800">
            Support: <a href="mailto:support@ekubur.my" className="text-primary-700 hover:underline">support@ekubur.my</a>
          </p>

          <div className="mt-8 border-t border-neutral-200 pt-4">
            <Link to="/" className="text-sm text-primary-600 hover:underline">
              ← Back to home
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
